import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import classNames from 'classnames';
import styles from './list.module.less'; // <List spacing={...} /> uses this to pass the value of its
// spacing prop down to these disconnected <Li /> components

export var ListSpacingContext = React.createContext(null); // nested lists add spacing above first <Li /> component

var ListIsNestedContext = React.createContext(false);
var Li = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      otherProps = _objectWithoutProperties(props, ["children", "className"]);

  var inNestedList = useContext(ListIsNestedContext);
  var spacing = useContext(ListSpacingContext);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classNames(className, styles['list-item'], styles["list-item-spacing-".concat(spacing)], !inNestedList && styles['list-item-not-nested'])
  }, otherProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(ListIsNestedContext.Provider, {
    value: true
  }, children));
});
Li.displayName = 'Li';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');

  Li.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };
}

export default Li;